import './App.css';
import './config/pdfConfig'; // Initialize PDF.js worker early
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import UploadSetup from './pages/UploadSetup';
import PresenterDashboard from './pages/PresenterDashboard';
import PresentationsDashboard from './pages/PresentationsDashboard';
import UserSettings from './pages/UserSettings';
import ViewerMain from './pages/ViewerMain';
import ViewerDepth from './pages/ViewerDepth';
import LandingPage from './pages/LandingPage';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import BetaAgreement from './pages/BetaAgreement';
import { Toaster } from './components/ui/toaster';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for existing auth tokens
    const userToken = localStorage.getItem('access_token');
    const adminToken = localStorage.getItem('admin_token');

    if (userToken) {
      setIsAuthenticated(true);
    }
    if (adminToken) {
      setIsAdmin(true);
    }

    setLoading(false);
  }, []);

  const handleLogin = () => {
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('user_id');
    localStorage.removeItem('username');
    setIsAuthenticated(false);
    window.location.href = '/';
  };

  const handleAdminLogin = () => {
    setIsAdmin(true);
  };

  const handleAdminLogout = () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_id');
    localStorage.removeItem('admin_username');
    setIsAdmin(false);
    window.location.href = '/';
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route 
            path="/" 
            element={
              isAuthenticated ? (
                <Navigate to="/upload-setup" replace />
              ) : (
                <LandingPage onLoginSuccess={handleLogin} />
              )
            } 
          />
          
          {/* Admin routes */}
          <Route 
            path="/admin" 
            element={
              isAdmin ? (
                <AdminDashboard onLogout={handleAdminLogout} />
              ) : (
                <AdminLogin onLoginSuccess={handleAdminLogin} onBack={() => window.location.href = '/'} />
              )
            } 
          />

          {/* Protected app routes */}
          <Route 
            path="/upload-setup" 
            element={
              isAuthenticated ? (
                <UploadSetup onLogout={handleLogout} />
              ) : (
                <Navigate to="/" replace />
              )
            } 
          />
          <Route 
            path="/upload-setup/:presentationId" 
            element={
              isAuthenticated ? (
                <UploadSetup onLogout={handleLogout} />
              ) : (
                <Navigate to="/" replace />
              )
            } 
          />
          <Route 
            path="/my-presentations" 
            element={
              isAuthenticated ? (
                <PresentationsDashboard userId={localStorage.getItem('user_id')} />
              ) : (
                <Navigate to="/" replace />
              )
            } 
          />
          <Route 
            path="/settings" 
            element={
              isAuthenticated ? (
                <UserSettings onLogout={handleLogout} />
              ) : (
                <Navigate to="/" replace />
              )
            } 
          />
          <Route 
            path="/presenter/:sessionId" 
            element={
              isAuthenticated ? (
                <PresenterDashboard />
              ) : (
                <Navigate to="/" replace />
              )
            } 
          />
          
          {/* Viewer routes - public access for viewers */}
          <Route path="/view/:sessionId" element={<ViewerMain />} />
          <Route path="/view/:sessionId/depth" element={<ViewerDepth />} />
          
          {/* Beta Agreement - public access */}
          <Route path="/beta-agreement" element={<BetaAgreement />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
